import React, { useState, useEffect, useRef } from "react";

import { api } from "./pureFunctions";
import "./styles/projektstatus.css";

import { header, host } from "./globalVariables";

import Nutzergrafik from "./Nutzergrafik";
import { getStaticData, parseOODate } from "./pureFunctions";
import NutzergrafikEinkauf from "./NutzergrafikEinkauf";
import NutzerauswertungsOptionen from "./NutzerauswertungOptionen";
import { getAppointmentsWithLocations } from "./networkFunctions";
import NutzergrafikTermine from "./NutzergrafikTermine";
import { useConfig } from "./ConfigContext";

const initOptionen = [
   "Einkaufstermine (vergangen)",
   "Einkaufstermine (offen)",
   "In Bewertung",
   "In Vorlauf",
   "Im Verkauf",
   "In Abwicklung",
   "Auswertung Vergleich Verkaufte Objekte",
];

export default function EinkaufStatistik({}) {
   const config = useConfig();
   const [selectedUser, setSelectedUser] = useState();
   const [loading, setLoading] = useState(false);
   const [estates, setEstates] = useState([]);
   const [termine, setTermine] = useState();
   const [auftragsDatumEstates, setAuftragsDatumEstates] = useState();
   const [verkaufsDatumEstates, setVerkaufsDatumEstates] = useState();
   const [auftragsDatumEstates2025, setAuftragsDatumEstates2025] = useState([]);
   const [verkaufsDatumEstates2025, setVerkaufsDatumEstates2025] = useState([]);
   const [einkaufstermine, setEinkaufstermine] = useState([]);
   const [besichtigungstermine, setBesichtigungstermine] = useState([]);
   const [graphDataBesichtigung, setGraphDataBesichtigung] = useState();
   const [users, setUsers] = useState();
   const [timeLimits, setTimeLimits] = useState(() => {
      const oldOptions = JSON.parse(localStorage.getItem("nutzerauswertungTimelimits"));
      return false ? oldOptions : { start: new Date(), end: new Date(new Date().getTime() + 86400000) };
   });

   const [benutzerOptionen, setBenutzerOptionen] = useState(() => {
      const oldOptions = JSON.parse(localStorage.getItem("nutzerauswertungUserOpt"));
      return false ? oldOptions : {};
   });
   async function getEstates(params) {
      
      let parameters = structuredClone(config.stats.ek.parameters);
      parameters.filter.status2 = [
         {
            op: "IN",
            val: Object.keys(config.stats.ek.stufen),
         },
      ];
      if (benutzerOptionen && Object.keys(benutzerOptionen).length) {
         parameters.filter.benutzer = [{ op: "IN", val: Object.keys(benutzerOptionen).map((item) => item) }];
      }

      await api.post("/api/readEstates", { parameters }, header).then((data) => {
         console.log(data.data);
         setEstates(data.data);
      });
   }

   async function getEstatesAuftrag2025(params) {
      /* let parameters = {
         data: ["objektnr_extern", "status2", "benutzer"],
         filter: {
            status2: [
               {
                  op: "IN",
                  val: [
                     "ind_Schl_5021",
                     "ind_Schl_2927",
                     "status2obj_aktiv", "ind_Schl_2929",
                     "fremd_verkauft_vermietet",
                     "auftrag_entzogen",
                     "verkauft",
                  ],
               },
            ], //in vorlauf offline, in vorlauf online, ..., in abwicklung
         },
         listlimit: 500,
         listoffset: 0,
         sortby: { objektnr_extern: "DESC" },
      }; */
      let parameters = structuredClone(config.stats.ek.parameters);
      parameters.filter.status2 = [
         {
            op: "IN",
            val: Object.keys(config.stats.ek.stufen),
         },
      ];

      if (benutzerOptionen && Object.keys(benutzerOptionen).length) {
         parameters.filter.benutzer = [{ op: "IN", val: Object.keys(benutzerOptionen).map((item) => item) }];
      }
      if (true) {
         //Auftrag seit
         parameters.filter[config.estate.auftragsdatum] = [{ op: "BETWEEN", val: params.timespan }];
      }
      let newEstatesAll = [];
      let i = 0;
      let estateResponse;
      do {
         console.log(parameters);
         estateResponse = await api.post("/api/readEstates", { parameters }, header).then((data) => {
            console.log(data.data);
            return data.data;
         });

         newEstatesAll.push(...estateResponse);
         i++;
         parameters.listoffset = 500 * i;
         console.log(estateResponse.length);
      } while (estateResponse.length >= 500);

      setAuftragsDatumEstates2025(newEstatesAll);
      setAuftragsDatumEstates((prev) => ({ ...prev, [params.year]: newEstatesAll }));
   }

   async function getEstatesVerkauf2025(params) {
      let parameters = {
         data: ["objektnr_extern", "status2", "benutzer"],
         filter: {
            status2: [
               {
                  op: "IN",
                  val: [
                     "verkauft",
                  ],
               },
            ], //in vorlauf offline, in vorlauf online, ..., in abwicklung
         },
         listlimit: 500,
         listoffset: 0,
         sortby: { objektnr_extern: "DESC" },
      };
      if (benutzerOptionen && Object.keys(benutzerOptionen).length) {
         parameters.filter.benutzer = [{ op: "IN", val: Object.keys(benutzerOptionen).map((item) => item) }];
      }
      if (true) {
         //verkauft am
         parameters.filter.verkauft_am = [{ op: "BETWEEN", val: ["2024-01-01", "2025-01-01"] }];
      }
      let newEstatesAll = [];
      let i = 0;
      let estateResponse;
      do {
         console.log(parameters);
         estateResponse = await api.post("/api/readEstates", { parameters }, header).then((data) => {
            console.log(data.data);
            return data.data;
         });

         newEstatesAll.push(...estateResponse);
         i++;
         parameters.listoffset = 500 * i;
         console.log(estateResponse.length);
      } while (estateResponse.length >= 500);

      setVerkaufsDatumEstates2025(newEstatesAll);
   }

   async function getTermine(myTerminArten) {
      let timeLimit = parseOODate(timeLimits.start, timeLimits.end);

      let parameters = {
         data: ["id", "type", "subject", "status", "date", "location", "users", "contacts", "estate"],
         filter: {
            startDate: timeLimit[0],
            endDate: timeLimit[1],
            // isDone: false,
            isCancelled: false,
            type: [{ op: "IN", val: myTerminArten }],
         },
         listlimit: 500,
         listoffset: 0,
      };
      if (benutzerOptionen && Object.keys(benutzerOptionen).length) {
         parameters.filter.userIds = Object.keys(benutzerOptionen).map((item) => item);
      }
      console.log(parameters);

      let [terminResponse, fullDataTermin, newAvailableUsers] = await getAppointmentsWithLocations(parameters);

      console.log(terminResponse);

      // setAlleTermine(terminResponse);
      console.log(fullDataTermin);

      return [terminResponse, fullDataTermin];
   }

   async function getData() {
      let [newestatekacheln, cleanUserData, newfieldConfiguration] = await getStaticData();

      console.log(cleanUserData);

      setUsers(cleanUserData.userObject);

      await getEstates("current");
      config.company === "baur" &&
         (await getEstatesAuftrag2025({ year: "2024", timespan: ["2024-01-01", "2025-01-01"] }));
      config.company === "baur" && (await getEstatesVerkauf2025());

      for (let i = 0; i < config.stats.ek.termine; i++) {
         let [terminResponse, fullDataTermin] = await getTermine(config.stats.ek.termine[i].arten);
         setTermine(
            terminResponse.map((item) => ({
               type: item.elements.type,
               datum: new Date(item.elements.date.start),
               benutzer: item.elements.users ? item.elements.users[0] : "",
               contacts: item.elements.contacts ? item.elements.contacts[0] : "",
            })),
         );
      }

      let [ektResponse, fullDataEKTTermin] = await getTermine(config.stats.ek.termine[0].arten);
      console.log(ektResponse);

      setEinkaufstermine(
         ektResponse.map((item) => ({
            datum: new Date(item.elements.date.start),
            benutzer: item.elements.users ? item.elements.users[0] : "",
            contacts: item.elements.contacts ? item.elements.contacts[0] : "",
         })),
      );

      let [besichtResponse, fullDataBesichtTermin] = await getTermine(config.stats.ek.termine[1].arten);
      console.log(besichtResponse);

      const newBesichtigungstermine = besichtResponse.map((item) => ({
         type: item.elements.type,
         datum: new Date(item.elements.date.start),
         benutzer: item.elements.users ? item.elements.users[0] : "",
         contacts: item.elements.contacts ? item.elements.contacts[0] : "",
      }));

      setBesichtigungstermine(newBesichtigungstermine);

      calcGraphBesichtigung(newBesichtigungstermine, cleanUserData.userObject);
   }

   useEffect(() => {
      setLoading(true);
      getData();

      setLoading(false);
   }, []);

   function calcGraphBesichtigung(myTermine, myUsers) {
      if (myTermine && myUsers) {
         const heute = new Date();
         const userTerminData = {};

         myTermine
            .filter((item) => item.benutzer)
            .filter((item) => item.type.value === "Besichtigung bestätigt")
            .forEach((item) => {
               const parsedDatum = new Date(item.datum);
               // let monat = parsedDatum.getMonth();
               if (item.benutzer === undefined) {
                  console.log(item);
               }
               let itemuser = item.benutzer.id;

               if (!userTerminData[itemuser]) {
                  userTerminData[itemuser] = { bbpast: [], bbfuture: [], bpast: [], bfuture: [] };
               }

               if (parsedDatum < heute) {
                  userTerminData[itemuser].bbpast.push(item);
               } else {
                  userTerminData[itemuser].bbfuture.push(item);
               }
            });

         myTermine
            .filter((item) => item.benutzer)
            .filter((item) => item.type.value === "Besichtigung")
            .forEach((item) => {
               const parsedDatum = new Date(item.datum);
               // let monat = parsedDatum.getMonth();
               if (item.benutzer === undefined) {
                  console.log(item);
               }
               let itemuser = item.benutzer.id;

               if (!userTerminData[itemuser]) {
                  userTerminData[itemuser] = { bbpast: [], bbfuture: [], bpast: [], bfuture: [] };
               }

               if (parsedDatum < heute) {
                  userTerminData[itemuser].bpast.push(item);
               } else {
                  userTerminData[itemuser].bfuture.push(item);
               }
            });

         console.log(userTerminData);

         setGraphDataBesichtigung(
            Object.keys(userTerminData).map((item) => ({
               ["name"]: myUsers[item] ? myUsers[item].Name : item,
               ["Besichtigung Vergangen"]: userTerminData[item].bpast.length,
               ["Besichtigung Offen"]: userTerminData[item].bfuture.length,
               ["Besichtigung bestätigt Vergangen"]: userTerminData[item].bbpast.length,
               ["Besichtigung bestätigt Offen"]: userTerminData[item].bbfuture.length,
            })),
         );
      }
   }

   return (
      <>
         <title>Nutzerauswertung</title>
         <NutzerauswertungsOptionen
            initOptionen={initOptionen}
            userObjects={users}
            benutzerOptionen={benutzerOptionen}
            setBenutzerOptionen={setBenutzerOptionen}
            timeLimits={timeLimits}
            setTimeLimits={setTimeLimits}
            getData={getData}
            initialshow={false}
            placement={"start"} //'start', 'end', 'top', 'bottom'
         />
         <div className="projektstatus p-0">
            <div className="projektstatus-l1">
               <div className="">
                  {!loading && (
                     <Nutzergrafik
                        users={users}
                        estates={estates}
                        selectedUser={selectedUser}
                        setSelectedUser={setSelectedUser}
                        statConfig={config.stats.ek}
                     />
                  )}
                  {!loading && <NutzergrafikEinkauf einkaufstermine={einkaufstermine} users={users} />}
                  {!loading && (
                     <NutzergrafikTermine
                        termine={besichtigungstermine}
                        graphDataBesichtigung={graphDataBesichtigung}
                        users={users}
                        heading={"Besichtigungen"}
                        terminArt={["Besichtigung", "Besichtigung bestätigt"]}
                     />
                  )}
               </div>
            </div>
         </div>
      </>
   );
}
